export const NEXT_STATE = "NEXT_STATE";
export const PREVIOUS_STATE = "PREVIOUS_STATE";
export const SAVE_ACTIVE_COMPANY = "SAVE_ACTIVE_COMPANY";
export const RESET_STATE = "RESET_STATE";
export const SET_NEXT_STEP = "SET_NEXT_STEP";
export const SET_ACTIVE_COMPANY = "SET_ACTIVE_COMPANY";
export const SET_ACTIVE_COMPANY_IS_EDITABLE = "SET_ACTIVE_COMPANY_IS_EDITABLE";
